import React, { useState, useEffect } from "react";
import * as sweetalert from "sweetalert";
import axios from "axios";
import { getAllBanks, getAllPaymentMethods } from "../../../services";
import Controls from "../global/controls/Controls";
import { useForm, Form } from "../Notifcations/useForm";
import { Grid } from "@material-ui/core";
import { getEPaymentConfig } from "../../../services/EPaymentConfig";
import packageJson from "../../../../package.json";
import ConfirmDialog from "../global/ConfirmDialogCon";

export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export default function Config_Epayment() {
  const [Paymentconfigration, setGetPaymentconfigration] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [discount_fatora_bank, setDiscount_fatora_bank] = useState([]);
  const [increase_sell_percent, setIncrease_sell_percent] = useState([]);
  const [Profit, setProfit] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [Banks, setBanks] = useState([]);
  const [confirmDialog2, setConfirmDialog2] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [loadingFatora, setLoadingFatora] = useState(false);
  useEffect(() => {
    setIsLoading(true);
    getEPaymentConfig()
      .then((res) => {
        setGetPaymentconfigration(res);
        setDiscount_fatora_bank(res.discount_fatora_bank);
        setIncrease_sell_percent(res.increase_sell_percent);
        setIsLoading(true);
      })
      .catch((err) => {
        setGetPaymentconfigration([]);
        setIsLoading(false);
      });
    getAllBanks().then((res) => {
      setBanks(res);
    });
    getAllPaymentMethods()
      .then((res) => {
        setPaymentMethod(res.data);
        setIsLoading(true);
      })
      .catch((err) => {
        setGetPaymentconfigration([]);
        setIsLoading(false);
      });

    return () => {};
  }, []);
  useEffect(() => {
    if(loadingFatora === true && !validate()) {
    setTimeout(() => {
      // After the timeout, reset the loading state
      setLoadingFatora(false);
      // Your other logic here
    }, 2000); // Adjust the timeout duration as needed
    }
  }, [loadingFatora]);
  useEffect(() => {}, [discount_fatora_bank, increase_sell_percent]);
  const initialFValues = {
    mobile: "",
    national_id: "",
    name: "",
    paymentId: "",
    amount: "",
  };
  const validate = (fieldValues = loginInput) => {
    let temp = { ...errors };
    if ("mobile" in fieldValues) {
      if (fieldValues.mobile == "") {
        temp.mobile = " رقم الموبايل مطلوب";
      } else if (!/[0-9]/.test(fieldValues.mobile)) {
        temp.mobile = "يجب أن يكون رقم الموبايل أرقام";
      }
      else if (fieldValues.mobile.length !== 10) {
        temp.mobile = "يجب أن يكون رقم الموبايل 10 أرقام";

      } 
      else {
        temp.mobile = "";
      }
    }
    if ("national_id" in fieldValues) {
      if (fieldValues.national_id == "") {
        temp.national_id = " الرقم الوطني مطلوب";
      } else if (!/[0-9]/.test(fieldValues.national_id)) {
        temp.national_id = "يجب أن يكون الرقم الوطني أرقام";
      } 
      else if (fieldValues.national_id.length !== 11) {
        temp.national_id = "يجب أن يكون رقم الوطني 11 رقمًا";
      }
      else {
        temp.national_id = "";
      }
    }
    if ("name" in fieldValues)
      temp.name = fieldValues.name ? "" : "الحقل مطلوب";
    if ("amount" in fieldValues)
      temp.amount = fieldValues.amount ? "" : "الحقل مطلوب";

    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };
  const validate2 = (fieldValues = loginInput) => {
    let temp = { ...errors };
    if ("mobile" in fieldValues) {
    if (fieldValues.mobile !== "" && !/^[0-9]+$/.test(fieldValues.mobile)) {
        temp.mobile = "يجب أن يكون رقم الموبايل أرقام فقط";
      } else if (fieldValues.mobile !== "" && fieldValues.mobile.length !== 10) {
        temp.mobile = "يجب أن يكون رقم الموبايل 10 أرقام";
      } 
      else {
        temp.mobile = "";
      }
    
    }
    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };
  const {
    loginInput,
    setLogin,
    errors,
    setErrors,
    handleInputChange,
    addForm,
  } = useForm(initialFValues, true, validate,validate2);
  // const handleChange = (e) => {
  //   const { name, value } = e.target;  // Get the field name and value from the input
  //   const parsedValue = parseFloat(value);  // Convert to float
  
  //   if (!isNaN(parsedValue)) {  // Only update if the value is a valid number
  //     if (name === "discount_fatora_bank") {
  //       setDiscount_fatora_bank(parsedValue);  // Update the state for discount
  //     } else if (name === "increase_sell_percent") {
  //       setIncrease_sell_percent(parsedValue);  // Update the state for profit/commission
  //     }
  //   } else {
  //     console.error("Invalid number entered");
  //   }
  // };
  const handleChange = (e) => {
    const { name, value } = e.target;  // Get the field name and value from the input
  
    // Check if the entered value is a valid number (but leave it as a string to maintain precision)
    if (!isNaN(value) && value.trim() !== '') {
      const parsedValue = value;  // Keep it as a string to maintain precision
  
      if (name === "discount_fatora_bank") {
        setDiscount_fatora_bank(parsedValue);  // Update the state for discount
      } else if (name === "increase_sell_percent") {
        setIncrease_sell_percent(parsedValue);  // Update the state for profit/commission
      }
    } else {
      console.error("Invalid number entered");
    }
  };
  
  const handleSubmit = () => {
 
    if (validate()) {
      setLoadingFatora(true);
      const bodyFormData = new FormData();
      bodyFormData.append("discount_fatora_bank", discount_fatora_bank);
      bodyFormData.append("increase_sell_percent", increase_sell_percent);
     
      axios
        .post(`${BaseUrl}/api/updateEPaymentConfig/1`, bodyFormData, {
          withCredentials: true,
        })
        .then((res) => {
          if (res.data.status === true) {
            setLoadingFatora(false);
            sweetalert(res.data.msg, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            }).then((res) => {
              window.location.reload();
            });
          } else {
            setLoadingFatora(false);
            sweetalert(res.data.msg, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            });
          }
    });
    }else{

    }
  };
 

  useEffect(() => {
    validate2(loginInput);
  }, [loginInput]);
  return (
    <div className="main-div">
      <h3 className="titlepage">إعدادات الدفع الإلكتروني</h3>
      <Grid className="form-group new-design" >
        <Grid container maxWidth="sm" spacing={4}>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="نسبة الخصم  البنك"
              name="discount_fatora_bank"
              variant="outlined"
              fullWidth
              onChange={handleChange}
              value={discount_fatora_bank}
              className="form-control"
              error={errors.discount_fatora_bank}
              
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="نسبة الربح من العملية (العمولة)"
              name="increase_sell_percent"
              variant="outlined"
              fullWidth
              onChange={handleChange}
              value={increase_sell_percent}
              className="form-control"
              error={errors.increase_sell_percent}
              
            />
          </Grid>
         
        
        </Grid>

        {/* <Grid item md={6} xs={12} spacing={2} class="div-btn-submit"> */}
        <Grid item md={6} xs={12} spacing={2} class="div-btn-submit"  style={{diplay:'flex', justifyContent:'center'}}>
          {loadingFatora === true ? (
            <Controls.Button
              type="submit"
              text=<div class="spinner center">
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
              </div>
              variant="contained"
              className="btn-submit"
            ></Controls.Button>
          ) : (
          <>
            <Controls.Button
              type="submit"
              text={"تعديل"}
             
              onClick={() => {
                if(validate()){
                    setConfirmDialog2({
                      isOpen: true,
                      title: "هل تريد القيام بهذه العملية",
                      subTitle: "",
                      onConfirm: () => {
                        handleSubmit();
                      },
                    });
                    }
                  }}
              variant="contained"
              className="btn-submit"
            ></Controls.Button>
                    <ConfirmDialog
                confirmDialog={confirmDialog2}
                setConfirmDialog={setConfirmDialog2}
              />
          </>
          )}
        </Grid>
      </Grid>
    </div>
  );
}
